import { render, staticRenderFns } from "./pendamping-ppbkl.vue?vue&type=template&id=d688a88e&scoped=true"
import script from "./pendamping-ppbkl.vue?vue&type=script&lang=js"
export * from "./pendamping-ppbkl.vue?vue&type=script&lang=js"
import style0 from "./pendamping-ppbkl.vue?vue&type=style&index=0&id=d688a88e&prod&lang=scss"
import style1 from "./pendamping-ppbkl.vue?vue&type=style&index=1&id=d688a88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d688a88e",
  null
  
)

export default component.exports